import {Button} from '@luminopia/react-toolbox/lib/button'
import {Eye, EYES} from 'core/api/prescription'
import {DeviceType} from 'core/api/study_coordinator'
import SelectField from 'core/components/form/select-field'
import TextField from 'core/components/form/text-field'
import {IanaTimezone} from 'core/utils/timezone'
import * as React from 'react'
import {Field, FormProps} from 'redux-form'
import {FormError} from 'study_coordinator/components/FormError'

export interface IFormFields {
  subjectIdentifier: string
  age: number
  accessCode: string
  deviceType: string
  timezone: IanaTimezone
  language: string
  prescribingNpi: string
  partnerOrderId: string
  amblyopicEye: Eye
}

export interface IProps extends FormProps<IFormFields, IProps, {}> {
  isFetching: boolean
  ageOptions: number[]
  deviceTypeOptions: DeviceType[]
  subjectIdentifierAllowedInput?: RegExp
  subjectIdentifierDisabled?: boolean
  onMount?: () => void
}

export interface IComponentState {
  prescribingNpi: string
  partnerOrderId: string
}

export class SubjectFormBase extends React.PureComponent<IProps, IComponentState> {
  public render() {
    const { handleSubmit, /*pristine, submitting,*/ error } = this.props
    const subjectIdentifierProps = {
      label: 'Subject ID',
      placeholder: 'Subject ID',
      allowedInput: this.props.subjectIdentifierAllowedInput,
    }
    const prescribingNpiProps = {
      label: 'Prescribers NPI',
      placeholder: 'Prescribers NPI',
    }
    const partnerOrderIdProps = {
      label: 'Phil Patient ID',
      placeholder: 'Phil Patient ID',
      type: 'hidden',
    }
    const amblyopicEyeProps = {
      label: 'Amblyopic Eye',
      options: [
        { label: 'Select' },
        ...EYES.map((eye) => ({
          value: eye,
          label: eye,
        })),
      ],
    }
    return (
      <form onSubmit={handleSubmit}>
        <FormError>{error}</FormError>
        {!this.props.subjectIdentifierDisabled
          && <Field name='subjectIdentifier' component={TextField} props={subjectIdentifierProps} />}
        {/* <Field name='age' component={SelectField} props={ageProps} />
        <Field name='deviceType' component={SelectField} props={deviceTypeProps} />
        <Field name='timezone' component={SelectField} props={timezoneProps} /> */}
        <Field name='prescribingNpi' component={TextField} props={prescribingNpiProps} />
        <Field name='partnerOrderId' component={TextField} type='hidden' props={partnerOrderIdProps} />
        <Field name='amblyopicEye' component={SelectField} props={amblyopicEyeProps} />
        <Button
          type='submit'
          label='Add'
          // disabled={pristine || submitting}
          disabled={false}
          raised
          primary
        />
      </form>
    )
  }

  public componentDidMount() {
    if (this.props.onMount) this.props.onMount()
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/subjects/subject-form/subject-form-base.tsx